module.exports = __webpack_public_path__ + "47e6838605e8848fe754aeb5ac9d9a7d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-22.png
// module id = 2321
// module chunks = 0